import { Ability } from '@casl/ability'
import { unpackRules } from '@casl/ability/extra'

export { AbilityProvider, Can, useAbilities } from './AbilityContext'

export const importAbilities = (abilities) => {
  return new Ability<[Action, Subject]>(unpackRules(abilities))
}

export type Action = 'view' | 'mutate' | 'create' | 'read' | 'update' | 'delete'

export type View =
  | 'Dashboard/Home'
  | 'Dashboard/Order'
  | 'Dashboard/Orders'
  | 'Dashboard/Kits'
  | 'Dashboard/Kit'
  | 'Dashboard/RecoveryCertificate'
  | 'Dashboard/RecoveryCertificates'
  | 'Dashboard/GenerateKitIds'
  | 'Dashboard/GenerateDiscountCodes'
  | 'Dashboard/Vision'
  | 'Dashboard/VisionManifest'
  | 'Dashboard/Batch'
  | 'Dashboard/Results'
  | 'Dashboard/EmailQueue'
  | 'Dashboard/ThirdParty'
  | 'Dashboard/ThirdParties'
  | 'Dashboard/RapidTesting/CaptureResults'
  | 'Dashboard/RapidTesting/ChooseSession'
  | 'Dashboard/NewSession'
  | 'Dashboard/RapidTesting/RapidSession'
  | 'Dashboard/RapidTesting/RapidSessions'
  | 'Dashboard/DiscountCodes/DiscountCodeDetails'
  | 'Dashboard/PHE'
  | 'Dashboard/PHE/Day2And8SalesCounts'
  | 'Dashboard/IdGenerationBatches'
  | 'Dashboard/PhotoVerificationQueue'
  | 'Dashboard/PhotoEscalationQueue'
  | 'Dashboard/DiscountCodes/StaticDiscountCodes'
  | 'Dashboard/Biograd'
  | 'Dashboard/DPD'
  | 'Dashboard/TDL'
  | 'Dashboard/ArchivedResultQueue'
  | 'Dashboard/Video/VideoPage'
  | 'Dashboard/Video/VideoQueuePage'
  | 'Dashboard/Video/VideoAppointments'

export type Mutate =
  | 'abortOutboundEmail'
  | 'abortOutboundSms'
  | 'addResult'
  | 'addResultNote'
  | 'addThirdParty'
  | 'addOrderToCurrentBatch'
  | 'amendAndResendCertificate'
  | 'amendResultKitId'
  | 'archiveResult'
  | 'beginEmailVerification'
  | 'beginRegistration'
  | 'cancelOrder'
  | 'cancelOrderShipment'
  | 'changeKitSku'
  | 'changeKitStatus'
  | 'changeOrderEmail'
  | 'claimNextResult'
  | 'claimResult'
  | 'closeBatch'
  | 'completeVideoSupervision'
  | 'confirmRegistration'
  | 'createIdGenerationBatch'
  | 'createMultiUseDiscountCode'
  | 'createRapidSession'
  | 'createUniquePlfRef'
  | 'deleteFailedTdlResults'
  | 'escalateResult'
  | 'generateDiscountCodes'
  | 'generateKitIds'
  | 'getNextVideoSupervision'
  | 'ignoreResult'
  | 'importResult'
  | 'joinVideoQueue'
  | 'markIdGenerationBatchDownloaded'
  | 'markKitObserved'
  | 'matchResult'
  | 'placeOrder'
  | 'registerKit'
  | 'resendBatch'
  | 'reshipOrder'
  | 'resendEmailVerification'
  | 'revokeDiscountCodes'
  | 'sendOutboundEmail'
  | 'sendRegReminderEmail'
  | 'startNewBatch'
  | 'unClaimResult'
  | 'uncompleteKit'

export type Subject = View | Mutate

export type Abilities = Ability<[Action, Subject]>
